export default "/images/framework/AddIcon.54feae77.svg?54feae77";